import { render, staticRenderFns } from "./RouteCreateTemplate.vue?vue&type=template&id=fb93f4a6&scoped=true&"
import script from "./RouteCreateTemplate.vue?vue&type=script&lang=js&"
export * from "./RouteCreateTemplate.vue?vue&type=script&lang=js&"
import style0 from "./RouteCreateTemplate.vue?vue&type=style&index=0&id=fb93f4a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb93f4a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VLayout,VRow})
